import { render } from "./Order.vue?vue&type=template&id=cc3ace92&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=cc3ace92&lang=less&scoped=true"
import "./Order.vue?vue&type=style&index=1&id=cc3ace92&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3ace92"]])

export default __exports__